import clsx from 'clsx';
import "./styles.scss";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  buttonType?: "default" | "outline" | "filled" | "primary";
}

export function Button({
  children,
  className,
  buttonType = "default",
  ...rest
}: ButtonProps) {
  if (buttonType === "outline") {
    return (
      <button
        {...rest}
        className={clsx(
          'flex h-10 items-center bg-transparent hover:bg-[var(--primary)] text-[var(--primary)] font-bold hover:text-white py-2 px-4 border border-[var(--primary)] hover:border-transparent rounded-2xl',
          className,
        )}
      >
        {children}
      </button>
    );
  }


  if (buttonType === "primary") {
    return (
      <button
        {...rest}
        className={clsx(
          'flex h-10 items-center rounded-lg btn-purple px-4 text-sm font-medium text-white transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--primary)] aria-disabled:cursor-not-allowed aria-disabled:opacity-50',
          className,
        )}
      >
        {children}
      </button>
    );
  }


  if (buttonType === "filled") {
    return (
      <button
        {...rest}
        className={clsx(
          'flex h-10 items-center bg-[var(--color-action-primary)] hover:bg-white text-white hover:text-[var(--color-action-primary)] font-bold py-2 px-4 border border-[var(--color-action-primary)] rounded-2xl transition-colors',
          className,
        )}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      {...rest}
      className={clsx(
        'flex h-10 items-center rounded-lg bg-[var(--primary)] px-4 text-sm font-medium text-white transition-colors hover:bg-[#5a3282] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--primary)] active:bg-[#401e63] aria-disabled:cursor-not-allowed aria-disabled:opacity-50',
        className,
      )}
    >
      {children}
    </button>
  );
}

export function MainButton({
  children,
  className,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      className={clsx(
        'flex h-10 items-center btn-purple text-white py-2 px-4 border rounded-2xl',
        className,
      )}
    >
      {children}
    </button>
  )
}
